import React, { useCallback } from 'react';

import { Flavor } from '../../../../common/types';
import useFlavorStore from '../../../../common/store/useFlavorStore';
import useScrollStore from '../../../../common/store/useScrollStore';
import Banner from './Banner';
import Content from './Content';

const Accordion = ({ name, flavor, calorie, taste, aroma, pairsWell, active }: {
  name: string,
  flavor: Flavor,
  calorie: string,
  taste: string,
  aroma: string,
  pairsWell: string[],
  active: boolean
}) => {

  const setFlavor = useFlavorStore(useCallback(state => state.set, []));
  const isLocked = useScrollStore(useCallback(state => state.isLocked, []));

  const handleClick = () => { !isLocked && setFlavor(flavor) }

  return (
    <>
      <Banner
        onClick={handleClick}
        flavor={flavor}
        active={active}
        label={name}
      />

      <Content
        calorie={calorie}
        taste={taste}
        aroma={aroma}
        pairsWell={pairsWell}
        active={active}
      />
    </>
  );
}

export default Accordion;